import { ReactNode } from 'react';
import { Box, Grid } from '@mui/material';
import Breadcrumbs, { BreadcrumbItem } from '../../../components/Breadcrumbs';

interface PageNavigationProps {
  breadcrumbs?: BreadcrumbItem[]
  controls?: ReactNode[];
}

const PageNavigation = ({
  breadcrumbs,
  controls = [],
}: PageNavigationProps) => {
  return (
    <Box aria-label='Operations Navigation'>
      <Grid
        container
        direction='row'
        spacing={0}
        sx={{
          justifyContent: 'space-between',
          alignItems: 'center',
          pb: 2
        }}>
        {/* Left side - Breadcrumb or empty space */}
        <Breadcrumbs items={breadcrumbs ?? []} />

        {/* Right side - Controls */}
        {controls.length > 0 && (
          <Grid container direction='row' spacing={2} sx={{
            alignItems: 'center'
          }}>
            {controls.map((control, index) => (
              <Box key={index}>
                {control}
              </Box>
            ))}
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default PageNavigation;